import { render, staticRenderFns } from "./pagContainer.vue?vue&type=template&id=bbbf6018&scoped=true&"
import script from "./pagContainer.vue?vue&type=script&lang=ts&"
export * from "./pagContainer.vue?vue&type=script&lang=ts&"
import style0 from "./pagContainer.vue?vue&type=style&index=0&id=bbbf6018&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf6018",
  null
  
)

export default component.exports